export default {
  '_b._qhyy': 'Dili Değiştir',

  '_a._jzz': 'Yükleniyor...',
  '_a._jzgd': 'Daha Fazla Yükle',
  '_a._wct': 'Hoş Geldiniz',
  '_a._gd': 'Daha Fazla',
  '_a._bf': 'Oynat',
  '_a._bcz': 'Kaydediliyor...',
  '_a._sctp': 'Resim Yükle',

  '_dl._qssyx': 'Lütfen e-posta adresinizi girin',
  '_dl._qssmm': 'Lütfen şifrenizi girin',
  '_dl._ann': 'Giriş Yap',
  '_dl._hmyzh': 'Hesabınız yok mu?',
  '_dl._qzc': 'Kayıt Ol',
  '_dl._yzhl': 'Zaten hesabınız var mı?',
  '_dl._qdl': 'Giriş Yap',
  '_dl._srqrmm': 'Lütfen şifrenizi onaylayın',
  '_dl._sryqm': 'Lütfen davet kodunu girin',
  '_dl._sryzm': 'Lütfen doğrulama kodunu girin',
  '_dl._ljzc': 'Hemen Kayıt Ol',
  '_dl._zcbsty': 'Kayıt olmak, okuduğunuz ve kabul ettiğiniz anlamına gelir',
  '_dl._yszc': 'Gizlilik Politikası',
  '_dl._lcmmbyy': 'Şifreler eşleşmiyor',

  '_yzm._fsyzm': 'Doğrulama Kodu Gönder',
  '_yzm._cxfs': '({time}) Tekrar Gönder',
  '_yzm._fsz': 'Gönderiliyor...',
  '_yzm._fscg': 'Başarıyla Gönderildi',

  '_h._zrm': 'En Popüler',
  '_h._zxd': 'En Yeni',
  '_h._phb': 'Sıralama',
  '_h._qz': 'Duvar Kağıtları',
  '_h._ssww': 'Ara',
  '_h._lsjl': 'Geçmiş',
  '_h._gd': 'Daha Fazla',
  '_h._dl': 'Giriş Yap',
  '_h._ye': 'Bakiye',
  '_h._dj': 'Dondurulmuş',
  '_h._ybp': 'Kontrol Paneli',
  '_h._wdqb': 'Cüzdanım',
  '_h._scjl': 'Favoriler',
  '_h._xxzx': 'Mesaj Merkezi',
  '_h._fxhy': 'Arkadaşlarla Paylaş',
  '_h._bzzx': 'Yardım Merkezi',
  '_h._ggtf': 'Reklam Yerleştirme',
  '_h._bqtz': 'Telif Hakkı Yatırımı',
  '_h._sz': 'Ayarlar',

  '_sy._jx': 'Öne Çıkanlar',
  '_sy._xpfb': 'Yeni Çıkanlar',
  '_sy._gdsp': 'Daha Fazla Video',

  '_qz._jbqz': 'Özenle Seçilmiş Duvar Kağıdı Koleksiyonu',
  '_qz._ssqz': 'Duvar Kağıdı Ara',
  '_qz._qb': 'Tümü',
  '_qz._zrfg': 'Doğal Manzaralar',
  '_qz._cxys': 'Soyut Sanat',
  '_qz._csjz': 'Kentsel Mimari',
  '_qz._dmyx': 'Anime ve Oyunlar',
  '_qz._yzxk': 'Kozmos ve Yıldızlar',
  '_qz._yl': 'Önizleme',
  '_qz._xzqz': 'Duvar Kağıdı İndir',
  '_qz._fbl': 'Çözünürlük',
  '_qz._fl': 'Kategori',
  '_qz._jzz': 'Yükleniyor',
  '_qz._myzdpp': 'Eşleşen duvar kağıdı bulunamadı',

  '_sp._xyjscl': 'İzlemek için kilidin açılması gerekiyor',
  '_sp._cz': 'Yükleme Yap',
  '_sp._jsqj': 'Tüm Bölümlerin Kilidini Aç',
  '_sp._jsbj': 'Bu Bölümün Kilidini Aç',
  '_sp._sc': 'Favorilere Ekle',
  '_sp._fx': 'Paylaş',
  '_sp._jsqjjs': 'Tüm bölümlerin kilidini açmak için {a} ödemeyi onaylıyor musunuz?',
  '_sp._jsbjjs': 'Bu bölümün kilidini açmak için {a} ödemeyi onaylıyor musunuz?',
  '_sp._zfz': 'Ödeme işleniyor...',
  '_sp._qrzf': 'Ödemeyi Onayla',
  '_sp._qx': 'İptal',

  '_qz._smrc': 'Dağ Gün Doğumu',
  '_qz._cxjh': 'Soyut Geometri',
  '_qz._dsyj': 'Şehir Gece Manzarası',
  '_qz._dmfj': 'Anime Manzarası',
  '_qz._hhxk': 'Uçsuz Bucaksız Yıldızlı Gökyüzü',
  '_qz._slmw': 'Orman Sisi',
  '_qz._scld': 'Renk Akışı',
  '_qz._xdjz': 'Modern Mimari',

  '_qb._cbjl': 'Yatırma Geçmişi',
  '_qb._jyjl': 'İşlem Geçmişi',
  '_qb._bddz': 'Bağlı Adresler',
  '_qb._txjl': 'Çekme Geçmişi',

  '_m._tcdl': 'Çıkış Yap',
  '_m._cb': 'Yatır',
  '_m._tb': 'Çek',

  '_cb._ssdz': 'Para birimi veya adres ara',
  '_cb._bz': 'Para Birimi',
  '_cb._je': 'Tutar',
  '_cb._dz': 'Adres',
  '_cb._sj': 'Zaman',
  '_cb._cz': 'İşlem',
  '_cb._zwjl': 'Henüz işlem yok',
  '_cb._dny': 'Sayfa {a} / {b}',
  '_cb._jyxq': 'İşlem Detayları',
  '_cb._jydz': 'İşlem Adresi',
  '_cb._zt': 'Durum',
  '_cb._yqr': 'Onaylandı',
  '_cb._qb': 'Tümü',
  '_cb._jt': 'Bugün',
  '_cb._j7t': 'Son 7 Gün',
  '_cb._j30t': 'Son 30 Gün',
  '_cb._zw': 'Yok',
  '_cb._fzcg': 'Adres panoya kopyalandı',

  '_jyjl._ssdz': 'Para birimi veya adres ara',
  '_jyjl._lx': 'Tür',
  '_jyjl._je': 'Tutar',
  '_jyjl._ye': 'Bakiye',
  '_jyjl._dj': 'Dondurulmuş',
  '_jyjl._sj': 'Zaman',
  '_jyjl._cz': 'İşlem',
  '_jyjl._zwjyjl': 'Henüz işlem yok',
  '_jyjl._czsx': 'Filtreyi Sıfırla',
  '_jyjl._dny': 'Sayfa {a} / {b}',
  '_jyjl._jyxq': 'İşlem Detayları',
  '_jyjl._jylx': 'İşlem Türü',
  '_jyjl._jyje': 'İşlem Tutarı',
  '_jyjl._jyhye': 'İşlem Sonrası Bakiye',
  '_jyjl._djye': 'Dondurulmuş Tutar',
  '_jyjl._jysj': 'İşlem Zamanı',
  '_jyjl._jyzt': 'İşlem Durumu',
  '_jyjl._ywc': 'Tamamlandı',
  '_jyjl._qb': 'Tümü',
  '_jyjl._jt': 'Bugün',
  '_jyjl._j7t': 'Son 7 Gün',
  '_jyjl._j30t': 'Son 30 Gün',

  '_jyjl._tp1': 'Yatırma',
  '_jyjl._tp2': 'Çekme',
  '_jyjl._tp3': 'Ödeme',
  '_jyjl._tp4': 'Yatırma',
  '_jyjl._tp5': 'Dondur',
  '_jyjl._tp6': 'Kazançlar',
  '_jyjl._tp7': 'Davet Ödülü',
  '_jyjl._tp8': 'Giriş Ödülü',
  '_jyjl._tp9': 'Promosyon Kazançları',
  '_jyjl._tp10': 'Video Ödülü',
  '_jyjl._tp11': 'Kayıt Bonusu',
  '_jyjl._tp12': 'Çekilme reddedildi',
  '_jyjl._tp13': 'Mesaj Kırmızı Paket',

  '_jyjl._tp14': 'Dahili Aktarım',

  '_cb._shz': 'İnceleniyor',
  '_cb._yyg': 'Onaylandı',
  '_cb._ybh': 'Reddedildi',

  '_bddz._tjdz': 'Adres Ekle',
  '_bddz._ssdz': 'Adres Ara',
  '_bddz._bz': 'Para Birimi',
  '_bddz._dz': 'Adres',
  '_bddz._sysj': 'Son Kullanım',
  '_bddz._cz': 'İşlem',
  '_bddz._zwjl': 'Henüz adres yok',
  '_bddz._dny': 'Sayfa {a} / {b}',
  '_bddz._dzewm': 'Adres QR Kodu',
  '_bddz._fzdz': 'Adresi Kopyala',
  '_bddz._dzxq': 'Adres Detayları',
  '_bddz._wl': 'Ağ',
  '_bddz._tjsj': 'Ekleme Zamanı',
  '_bddz._bzwa': 'Not',
  '_bddz._ntq': '{a} gün önce',
  '_bddz._nxsq': '{a} saat önce',
  '_bddz._nfzq': '{a} dakika önce',
  '_bddz._ngg': 'Şimdi',
  '_bddz._dzyfz': 'Adres panoya kopyalandı',
  '_bddz._scqr': 'Silme Onayı',
  '_bddz._scqrdz': 'Bu adresi silmek istediğinizden emin misiniz?',
  '_bddz._qr': 'Onayla',
  '_bddz._qx': 'İptal',
  '_bddz._scdzcg': 'Adres başarıyla silindi',

  '_txjl._ztsx': 'Durum Filtresi',
  '_txjl._qbzt': 'Tüm Durumlar',
  '_txjl._shz': 'İnceleniyor',
  '_txjl._ytg': 'Onaylandı',
  '_txjl._yjj': 'Reddedildi',
  '_txjl._ssdz': 'Adres veya tutar ara',
  '_txjl._bz': 'Para Birimi',
  '_txjl._je': 'Tutar',
  '_txjl._dz': 'Adres',
  '_txjl._zt': 'Durum',
  '_txjl._sj': 'Zaman',
  '_txjl._cz': 'İşlem',
  '_txjl._zwjl': 'Henüz işlem yok',
  '_txjl._czsx': 'Filtreyi Sıfırla',
  '_txjl._dny': 'Sayfa {a} / {b}',
  '_txjl._jyxq': 'İşlem Detayları',
  '_txjl._skdz': 'Alıcı Adresi',
  '_txjl._jysj': 'İşlem Zamanı',
  '_txjl._jyzt': 'İşlem Durumu',
  '_txjl._fzdz': 'Adres panoya kopyalandı',

  '_cbsq._bz': 'Para Birimi',
  '_cbsq._wl': 'Ağ',
  '_cbsq._erwm': 'QR Kod',
  '_cbsq._fzdz': 'Adresi Kopyala',

  '_txsq._bz': 'Para Birimi',
  '_txsq._wl': 'Ağ',
  '_txsq._ye': 'Bakiye',
  '_txsq._sxf': 'Ücret',
  '_txsq._zxtx': 'Minimum Çekim',
  '_txsq._txdz': 'Çekim Adresi',
  '_txsq._qxztxdz': 'Lütfen çekim adresini seçin',
  '_txsq._txje': 'Çekim Tutarı',
  '_txsq._qsrtxje': 'Lütfen çekim tutarını girin',
  '_txsq._yxyzm': 'E-posta Doğrulama Kodu',
  '_txsq._qsryxyzm': 'Lütfen doğrulama kodunu girin',
  '_txsq._ljtx': 'Hemen Çek',

  '_jl._wxhd': 'Beğendiklerim',
  '_jl._lsjl': 'Geçmiş',

  '_xx._bt': 'Mesaj Merkezi',
  '_xx._wjl': 'Kayıt Yok',
  '_xx._zsmyxx': 'Henüz mesaj yok',
  '_xx._sxxx': 'Mesajları Yenile',
  '_xx._sxcg': 'Başarıyla yenilendi',

  '_fx._fxhy': 'Arkadaşlarla Paylaş',
  '_fx._smfx': 'Arkadaşlarla paylaşmak için QR kodunu tarayın',
  '_fx._jlsm': 'Ödül Açıklaması',
  '_fx._jlsm1': "1. Doğrudan davet ettiğiniz arkadaşlar (Seviye 1) size kazançlarının {a}%'ını verir.",
  '_fx._jlsm2': "2. Seviye 1 arkadaşlarınızın davet ettiği arkadaşlar (Seviye 2) size kazançlarının {a}%'ını verir.",
  '_fx._jlsm3': "3. Seviye 2 arkadaşlarınızın davet ettiği arkadaşlar (Seviye 3) size kazançlarının {a}%'ını verir.",
  '_fx._fzlj': 'Bağlantıyı Kopyala',

  '_bzzx._bzzx': 'Yardım Merkezi',
  '_bzzx._rhzczh': 'Hesap Nasıl Oluşturulur',
  '_bzzx._zclc': 'Kayıt Süreci',
  '_bzzx._rhzcxyh': 'Yeni hesap nasıl kaydedilir?',
  '_bzzx._rhzcxyh1': '"Kayıt Ol"a tıklayın, e-posta adresinizi girin, şifre belirleyin ve e-posta doğrulamasını tamamlayın.',

  '_bzzx._rhcz': 'Nasıl yükleme yapılır?',
  '_bzzx._rhcz1': 'Yükleme Süreci',
  '_bzzx._rhcz2': 'Detaylı yükleme talimatları',
  '_bzzx._rhcz3': "Cüzdanım'a tıklayın, Yatır'ı seçin, kripto para birimini seçin ve sağlanan adrese gönderin.",

  '_bzzx._rhjsdj': 'Kısa Diziler Nasıl Açılır',
  '_bzzx._rhjsdj2': 'Tekil bölümleri açmak için tıklayın.',

  '_bzzx._rhtx': 'Hesaptan Nasıl Çekilir',
  '_bzzx._rhtx1': "1. Cüzdanım > Çekme Adresleri'ne gidin, yeni adres ekleyin.<br>2. Çek'e tıklayın, para birimini seçin, tutarı girin ve bekleyin.",

  '_bzzx._qtwt': 'Diğer Sorular',
  '_bzzx._qtwt1': 'Destek ile nasıl iletişime geçilir?',
  '_bzzx._qtwt2': 'Çevrimiçi destek, e-posta veya telefon ile bize ulaşın.',
  '_bzzx._myzdwt': 'Aradığınız cevabı bulamadınız mı?',
  '_bzzx._khjybbzn': 'Ekibimiz size yardımcı olmaktan mutluluk duyacaktır.',
  '_bzzx._lxkf': 'Destekle İletişime Geç',

  '_ggtf._bt1': 'Reklam Yerleştirme',
  '_ggtf._splb': 'Video Listesi',
  '_ggtf._wcyd': 'Katılımım',
  '_ggtf._hdbm': 'Etkinlik Kodu',
  '_ggtf._tian': 'Gün',
  '_ggtf._kssj': 'Başlangıç Zamanı',
  '_ggtf._jssj': 'Bitiş Zamanı',
  '_ggtf._ddvp': 'VIP Seviye {a} ulaşın, kişi başı ortalama {b} katılım',
  '_ggtf._hdzt': 'Etkinlik Durumu',
  '_ggtf._wks': 'Başlamadı',
  '_ggtf._ycy': 'Katılındı',
  '_ggtf._qg': 'Hemen Satın Al',
  '_ggtf._mygdl': 'Daha fazla veri yok',
  '_ggtf._qgrtd': 'Çok fazla alıcı var, lütfen tekrar deneyin',
  '_ggtf._hdxq': 'Etkinlik Detayları',
  '_ggtf._hdjs': 'Etkinlik Açıklaması',
  '_ggtf._cyyq': 'Katılım Gereksinimleri',
  '_ggtf._zdtz': 'Minimum Yatırım',
  '_ggtf._vpdj': 'VIP Seviye',
  '_ggtf._rjcy': 'Ortalama Katılım',
  '_ggtf._gmje': 'Satın Alma Tutarı',
  '_ggtf._qsrgmje': 'Lütfen satın alma tutarını girin',
  '_ggtf._qx': 'İptal',
  '_ggtf._ljcy': 'Hemen Katıl',
  '_ggtf._ssjymm': 'İşlem şifresini girin',
  '_ggtf._qssjymm': 'Lütfen işlem şifresini girin',
  '_ggtf._ji': 'Seviye',
  '_ggtf._ci': 'defa',
  '_ggtf._zdgm': 'Minimum Satın Alma Tutarı',
  '_ggtf._zggm': 'Maksimum Satın Alma Tutarı',
  '_ggtf._zfz': 'Ödeme işleniyor...',

  '_wdtg._wjl': 'Henüz katılım yok',
  '_wdtg._tzje': 'Yatırılan Tutar',
  '_wdtg._zsy': 'Toplam Kazanç',
  '_wdtg._hdts': 'Etkinlik Süresi',
  '_wdtg._cysj': 'Katılım Zamanı',
  '_wdtg._qzf': 'Ödemeye Git',
  '_wdtg._jxz': 'Devam Ediyor',
  '_wdtg._djszje': 'Bekleyen Toplam Tutar',
  '_wdtg._gjb': 'Toplam {a} kayıt',
  '_wdtg._djs': 'Beklemede',
  '_wdtg._zrsy': 'Dünkü Kazanç',
  '_wdtg._dbl': 'İsteğe Bağlı Video Görüntüleme',
  '_wdtg._bfl': 'Oynatma Sayısı',
  '_wdtg._wdsy': 'Kazançlarım',
  '_wdtg._bqffc': 'Telif Hakkı Sahibi Payı',
  '_wdtg._mr0djs': "Dünkü kazançlar her gün 00:00'da hesaplanır",
  '_wdtg._jrsy': 'Bugünkü Kazanç',
  '_wdtg._mygd': 'Daha fazla veri yok',

  '_bqyy._bqyy': 'Telif Hakkı İşbirliği Randevusu',
  '_bqyy._qrbq': 'İşbirliği randevusunu onaylıyor musunuz?',
  '_bqyy._qx': 'İptal',
  '_bqyy._tjyy': 'Randevu Gönder',

  '_bqyy._spsq': 'Video Telif Hakkı İşbirliği Başvurusu',
  '_bqyy._spsy': 'Daha fazla trafik ve kazanç için videoları birlikte tanıtın!',
  '_bqyy._ljyy': 'Hemen Randevu Al',
  '_bqyy._sphz': 'Video Telif Hakkı İşbirliği Nedir?',
  '_bqyy._sphzsm': 'İşbirliği karşılıklı fayda için daha fazla görünürlük sağlar.',
  '_bqyy._sqhch': 'İşbirliği Faydaları',
  '_bqyy._llfz': 'Trafik Desteği',
  '_bqyy._llfzsm': 'Görünürlüğünüzü ve oynatma sayınızı artırın.',
  '_bqyy._sytg': 'Artırılmış Kazanç',
  '_bqyy._sytgsm': 'Daha yüksek reklam gelirlerinden yararlanın.',
  '_bqyy._yxhz': 'Öncelikli İşbirliği',
  '_bqyy._yxhzsm': 'Resmi etkinliklere öncelikli katılım.',
  '_bqyy._yytj': 'Randevu Koşulları',
  '_bqyy._sptg': 'Video Tanıtım Gereksinimleri',
  '_bqyy._sptgsm': 'En az 1 video tanıtımına katılın.',
  '_bqyy._yysm': 'Ekibimiz 3 iş günü içinde sizinle iletişime geçecektir.',

  '_ybp._wdsy': 'Kazançlarım',
  '_ybp._dqye': 'Mevcut Bakiye',
  '_ybp._jr': 'Bugün',
  '_ybp._jrzsy': 'Bugünkü Toplam Kazanç',
  '_ybp._ljzsy': 'Biriken Toplam Kazanç',
  '_ybp._tgfh': 'Promosyon Temettüleri',
  '_ybp._ljsy': 'Biriken Kazanç',
  '_ybp._bqsy': 'Telif Hakkı Kazançları',
  '_ybp._yqfh': 'Davet Temettüleri',
  '_ybp._mrsy': 'Günlük Kazanç',
  '_ybp._tgsy': 'Promosyon Kazançları',

  '_tjdz._tjxd': 'Yeni Adres Ekle',
  '_tjdz._xzbz': 'Para Birimi Seç',
  '_tjdz._qbdz': 'Cüzdan Adresi',
  '_tjdz._srdz': 'Lütfen cüzdan adresini girin',
  '_tjdz._qx': 'İptal',
  '_tjdz._bc': 'Kaydet',

  '_sz._smrz': 'Kimlik Doğrulama',
  '_sz._rzlx': 'Doğrulama Türü',
  '_sz._sfzzm': 'Kimlik Kartı Ön Yüz',
  '_sz._sfzfm': 'Kimlik Kartı Arka Yüz',
  '_sz._zsxm': 'Gerçek Ad',
  '_sz._qsrzsxm': 'Lütfen gerçek adınızı girin',
  '_sz._sfzhm': 'Kimlik Kartı Numarası',
  '_sz._qsrsfzhm': 'Lütfen kimlik kartı numaranızı girin',
  '_sz._yyzz': 'İşletme Lisansı',
  '_sz._qymc': 'Şirket Adı',
  '_sz._yyzzh': 'İşletme Lisans Numarası',
  '_sz._qsrqymc': 'Lütfen şirket adını girin',
  '_sz._qsryyzzh': 'Lütfen işletme lisans numarasını girin',
  '_sz._qx': 'İptal',
  '_sz._tjrz': 'Doğrulamayı Gönder',
  '_sz._zt': 'Durum',
  '_sz._gr': 'Bireysel',
  '_sz._qy': 'Şirket',
  '_sz._shz': 'İnceleniyor',
  '_sz._ytg': 'Onaylandı',
  '_sz._ybh': 'Reddedildi',

  '_mm._xgmm': 'Şifreyi Değiştir',
  '_mm._dqxg': 'Güvenlik için şifrenizi düzenli değiştirin',
  '_mm._dqmm': 'Mevcut Şifre',
  '_mm._xmm': 'Yeni Şifre',
  '_mm._qrxmm': 'Yeni Şifreyi Onayla',
  '_mm._qx': 'İptal',
  '_mm._qrxg': 'Değişikliği Onayla',

  '_jymm._xgjymm': 'İşlem Şifresini Değiştir',

  '_szzx._sz': 'Ayarlar',
  '_szzx._yrz': 'Doğrulandı',
  '_szzx._wrz': 'Doğrulanmadı',
  '_szzx._jymm': 'İşlem Şifresi',
  '_szzx._szjymm': 'İşlem şifresini ayarla veya değiştir',
  '_szzx._tcdl': 'Çıkış Yap',
  '_szzx._qdtcdl': 'Çıkış yapmak istediğinizden emin misiniz?',
  '_szzx._qrtc': 'Çıkışı Onayla',
  '_szzx._qx': 'İptal',

  '_yj._gy': 'Hakkımızda',

  '_yj._lxwm': 'Bizimle İletişime Geçin',

  '_yj._yszc': 'Gizlilik Politikası',

  '_yj._yhxy': 'Kullanıcı Sözleşmesi',

  '_cd._gszz': 'Şirket Nitelikleri',

  '_cd._wmyy': 'Kullanıcılara yasal, güvenli ve yüksek kaliteli video hizmetleri sunan eksiksiz sektör yeterliliklerine ve sertifikalarına sahibiz',

  '_cd._yyzz': 'Resmi kayıt bilgilerimizi ve iş kapsamımızı gösteren, şirketin yasal faaliyetinin geçerli kanıtı',

  '_cd._yyzz2': 'Platformun yasallığını ve uyumluluğunu garanti eden, yasal olarak alınmış şirket onaylı işletme lisansı',

  '_bz._lxkf': 'Müşteri hizmetleriyle iletişime geçmek için aşağıya tıklayın veya müşteri hizmetleri e-postası veya yardım hattı aracılığıyla bizimle iletişime geçin',

  '_sz._bjtx': 'Düzenle',

  '_sz._bjxx': 'Mesajı Düzenle',

  '_sz._tx': 'Avatar',

  '_sz._bcun': 'Kaydet',

  '_db._zskf': 'Destekle İletişime Geç',
  '_db._zsry': 'Özel Temsilci',
  '_db._wdq': 'Okunmamış',
  '_db._ydq': 'Okundu',

  '_sc._sctp': 'Resim Yükle',
  '_sc._xztp': 'Resim Seç',
  '_sc._fstp': 'Resmi Gönder',
  '_sc._qx': 'İptal',
  '_sc._hd': 'Tamam',

  '_zcyl._zcbt': 'Kayıt Bonusu',
  '_zcyl._djdkhb': 'Kırmızı zarfı açmak için dokun',
  '_zcyl._zclj': 'Kayıt Ödülü',
  '_zcyl._hmyzh': 'Hesabınız yok mu?',
  '_zcyl._qzc': 'Kayıt Ol',
  '_zcyl._qxdjhb': 'Lütfen önce ödülünüzü talep edin',
  '_zcyl._qwzc': 'Kayda Git',
  '_zcyl._hbysy': 'Ödül zaten kullanıldı',

  '_ggtg._qhz': "Transfer'e Git",
  '_ggtg._dqye': 'Mevcut Bakiye',
  '_ggtg._qcz': "Yatırma'ya Git",
  '_ggtg._hzje': 'Transfer Miktarı',
  '_ggtg._ljhz': 'Hemen Transfer Et',
  '_ggtg._yebz': 'Yetersiz Bakiye',

  '_sq._bhbt': 'Reddedildi',

  '_sq._bhyy': 'Reddedilme nedeni',

  '_xx._ntq': '{n} gün önce',

  '_xx._nxsq': '{n} saat önce',

  '_xx._nfzq': '{n} dakika önce',

  '_xx._nggq': 'Az önce',

  '_xx._djckgd': 'Daha fazlasını görüntülemek için tıklayın',

  '_ct._zt': 'Durum',

  '_ct._ljz': 'Bağlanıyor',

  '_ct._ylj': 'Bağlandı',

  '_ct._ltlieb': 'Sohbet Listesi',

  '_ct._bnhzj': 'Kendimle sohbet edemiyorum',

  '_ct._cylb': 'Üye Listesi',

  '_hb._fhb': 'Kırmızı Zarf',

  '_hb._dqye': 'Mevcut Bakiye',

  '_hb._fsd': 'Gönderilen Kişi',

  '_hb._hbje': 'Kırmızı Zarf Tutarı',

  '_hb._qshuru': 'Lütfen kırmızı zarf tutarını girin',

  '_hb._ljfs': "Gönder' Şimdi",

  '_hb._hbz': 'Kırmızı Zarf Duası',
  '_hb._qshuruzhu': 'Lütfen duanızı girin',

  '_sp._cuow': 'İzleyebilmeniz için 1-10. bölümlerin kilidini açmanız gerekiyor',

  '_bq._tzzq': 'Yatırım Süresi',

  '_bq._zrsy': 'Dünkü Kar',

  '_bq._bqtz': 'Telif Hakkı Yatırımı',

  '_bq._tzdj': 'Yatırım Tutarı',

  '_bq._zfjz': 'Ödeme 24 saat içinde yapılmalıdır, aksi takdirde feragat olarak kabul edilecektir!',

  '_bq._qzf': 'Ödeme Yap',

  '_bq.jz': 'Son Tarih',

  '_bq._ljzf': 'Şimdi Öde',

  '_bq._sqbz': 'Başvuru Notları (İsteğe Bağlı)',

  '_bq._sqbzsm': "Lütfen Başvuruyu Girin' Notlar",

  '_bq._zzsqz': 'Telif hakkı başvurusu devam ediyor, inceleme bekleniyor...',

  '_app._xz': 'ReelShortPro uygulamasını indirin',

  '_app._smerm': 'İndirmek için QR kodunu tarayın',

  '_app._xzbt': 'İndir',

  '_m._yhzz': 'Banka Havalesi',
  '_m._yhxx': 'Banka Bilgileri',
  '_m._yhmz': 'Banka Adı',
  '_m._yhdz': 'Banka Adresi',
  '_m._yhmc': 'Ad',
  '_m._yhzh': 'Hesap',
  '_m._yhlx': 'Tür',
  '_m._yhly': 'Yönlendirme',
  '_m._yhdm': 'Kod',
  '_m._yhbz': 'Not',
  '_m._fzxx': 'Bilgileri Kopyala',

  '_m._zts': 'İpuçları',

  '_m._zyd1': '1. Para transferi yaparken lütfen alıcının adını, hesap numarasını ve banka kodunu dikkatlice doğrulayın. Herhangi bir hata, havalenin kaybolmasına neden olabilir.',

  '_m._zyd2': "2. Aracı banka kesintileri nedeniyle yetersiz bakiye oluşmasını önlemek için 'Gönderici tüm ücretleri karşılar' seçeneğini seçmeniz önerilir.",

  '_m._zyd3': '3. Transferler genellikle 1-3 iş günü sürer. Lütfen sabırlı olun. Herhangi bir sorunuz varsa, lütfen müşteri hizmetleriyle iletişime geçin.',

  '_m._zyd4': '4. Başka sorularınız varsa, lütfen müşteri hizmetleriyle iletişime geçin.',

  '_m._jyh': 'İşlem Numarası',

  '_m._jyje': 'Tutar',

  '_sp._dbye': 'VOD Bakiyesi',
  '_sp.hzye': 'Transfer',
  '_sp._txje': 'Transfer Tutarı',
  '_sp._qsrtxje': 'Lütfen transfer tutarını girin',
  '_sp._ljhz': 'Şimdi Transfer Et',
  '_sp._yebz': 'Yetersiz bakiye',
  '_sp._qshuru': 'Lütfen doğru transfer tutarını girin',
  '_sp._fanh': 'Geri',

  '_adv._hdhwks': 'Etkinlik henüz başlamadı',
  '_adv._hdcg': 'Katılım başarılı',
  '_adv._jxz': 'Devam ediyor',
  '_adv._ywc': 'Tamamlandı',
  '_adv._djs': 'Ödeme bekleniyor',
  '_adv._qdycy': '{t} etkinliğine katılmak istediğinize emin misiniz?',
  '_adv._qrcy': 'Katılımı onayla',
  '_adv._qx': 'İptal',
  '_adv._qd': 'Onayla',

  '_dl._hy': 'Tekrar hoş geldiniz',
  '_dl._cj': 'Hesap oluştur',
  '_dl._zmm': 'Şifreyi sıfırla',
  '_dl._hyDesc': 'Harika içerikleri keşfetmeye devam etmek için hesabınıza giriş yapın',
  '_dl._cjDesc': "ReelShortPro'ya katılın ve heyecan verici yolculuğunuza başlayın",
  '_dl._zmmDesc': 'E-posta adresinizi girin, sıfırlama için doğrulama kodu gönderelim',
  '_dl._hlgqsp': 'Geniş HD film ve video kaynağı',
  '_dl._gxhty': 'Kişiselleştirilmiş öneri algoritmaları',
  '_dl._ffddsp': 'Zengin kısa videolar',
  '_dl._dlzh': 'Giriş yap',
  '_dl._sdndyx': 'Devam etmek için e-posta ve şifrenizi girin',
  '_dl._email': 'E-posta adresi',
  '_dl._qsryx': 'Lütfen e-posta adresinizi girin',
  '_dl._dlmm': 'Şifre',
  '_dl._qsrmm': 'Lütfen şifrenizi girin',
  '_dl._wjmm': 'Şifrenizi mi unuttunuz?',
  '_dl._immdl': 'Şimdi giriş yap',
  '_dl._hmyzh2': 'Hesabınız yok mu?',
  '_dl._ljzc2': 'Şimdi kaydol',
  '_dl._cjzh': 'Hesap oluştur',
  '_dl._jswmd': "ReelShortPro'ya katılın ve heyecan verici yolculuğunuza başlayın",
  '_zh._qszmm': 'Lütfen şifrenizi belirleyin',
  '_zh._qrmm': 'Şifreyi onayla',
  '_zh._qmm': 'Lütfen şifreyi tekrar girin',
  '_zc._yqm': 'Davet kodu',
  '_zc._sryqm': 'Lütfen davet kodunu girin',
  '_dl._yzm': 'Doğrulama kodu',
  '_dl._qsryzm': 'Lütfen doğrulama kodunu girin',
  '_dl._yjyzh': 'Zaten hesabınız var mı?',
  '_dl._zcbsty2': 'Kaydolarak şunları kabul ediyorsunuz',
  '_dl._zcbstyDesc': 'Gizlilik Politikası',
  '_dl._newmm': 'Yeni şifre',
  '_dl._qszxmm': 'Lütfen yeni şifre belirleyin',
  '_dl._qrmm': 'Şifreyi onayla',
  '_dl._qzcsrmm': 'Lütfen yeni şifreyi tekrar girin',
  '_dl._czmm': 'Şifreyi sıfırla',
  '_dl._xqlmm': 'Şifrenizi hatırladınız mı?',
  '_dl._fhdl': 'Girişe dön',
  '_dl._srdllmmbyz': 'Şifreler eşleşmiyor',
  '_dl._czcg': 'Şifre başarıyla sıfırlandı',
  '_h._zc': 'Kaydol'
}
